import { http } from '../utility/http.js'

const container = document.querySelector('.filtered-posts')
const postType = container?.getAttribute('data-posts') ?? ''
const filters = document.querySelector('.filters')
const filterButtons = document.querySelectorAll('.category-filter')
const filterCategory = filters?.getAttribute('data-filter') ?? ''

const resetFilters = document.querySelector('.clear-filters')
const urlParams = new URLSearchParams(window.location.search)
const value = parseInt(urlParams.get('cat'))

const api = `/wp-json/wp/v2/${postType}?orderby=date&order=desc&acf_format=standard`
let termArray = []
let currentPage = 1
let loadedPage = 0
let totalPages = 1
let categories = []

function filterPosts() {
	const termID = parseInt(this.getAttribute('data-term'))
	const exists = termArray.includes(termID)
	currentPage = 1

	if (!exists) {
		termArray.push(termID)
		this.classList.add('active')
	} else {
		const index = termArray.indexOf(termID)
		this.classList.remove('active')
		if (index !== -1) termArray.splice(index, 1)
	}

	categories = termArray.join(',')
	if (categories.length) {
		getPosts({ query: { [filterCategory]: categories } })
	} else {
		getPosts({})
	}

	if (resetFilters) {
		categories.length ? resetFilters.classList.add('active') : resetFilters.classList.remove('active')
	}
}

function clearFilters() {
	categories = []
	termArray = []
	currentPage = 1
	loadedPage = 0

	if (resetFilters) resetFilters.classList.remove('active')
	filterButtons.forEach(el => el.classList.remove('active'))

	getPosts({ page: currentPage })
}

function getPosts({ url = api, query = {}, per_page = 12, page = 1, clearDom = true } = {}) {
	const params = new URLSearchParams({
		...query,
		per_page,
		page,
	})

	http({
		url: `${url}&${params.toString()}`,
		success: (response, xhr) => {
			const posts = JSON.parse(response)
			totalPages = parseInt(xhr.getResponseHeader('x-wp-totalpages'))
			loadedPage = page
			renderPosts(container, posts, clearDom)
			renderLoadTrigger()
		},
	})
}

function loadPosts() {
	if (loadedPage !== currentPage) return
	if (currentPage >= totalPages) return

	currentPage = currentPage + 1

	if (categories.length) {
		getPosts({
			query: { [filterCategory]: categories },
			page: currentPage,
			clearDom: false,
		})
	} else {
		getPosts({
			page: currentPage,
			clearDom: false,
		})
	}
}

function renderPosts(container, posts, clearDom = true) {
	if (!container) return
	const fragment = document.createDocumentFragment()

	posts.map(post => {
		const template = renderPost(post)
		const element = document.createElement('div')
		element.innerHTML = template
		const itemEl = element.firstElementChild
		if (itemEl) fragment.appendChild(itemEl)
	})

	if (clearDom) {
		container.innerHTML = ''
	}
	container.appendChild(fragment)
}

function renderPost(post) {
	const title = post?.title?.rendered || ''
	const excerpt = post?.excerpt?.rendered || post?.acf?.banner_content || ''
	const link = post?.link || '#'

	// console.log(post.acf)

	const categories = post?.region || ''

	const x = post.acf?.banner_image?.x ?? '50'
	const y = post.acf?.banner_image?.y ?? '50'

	const cols = postType === 'news' ? 'col-4@medium' : 'col-6@medium';

	return `
		<div class="${cols}">
			<a href="${link}" class="card">
				${post.acf.banner_image?.sizes?.large && `
					<div class="card__image relative">
						<img 
							class="object-fit--absolute" 
							src="${post.acf.banner_image.sizes.large}" 
							style="object-position:${x}% ${y}%; ">
					</div>
				` || '' }
			
				<div class="card__content">
					<div class="card__content__inner first-last">
						<h4 class="heading-5">${title}</h4>
						${excerpt && `<div class="text-main first-last">${excerpt}</div>`}
						${categories && `
							<div class="grid gap-1 margin-top-2">
								${categories.map(category => `<span class="card__category">${category}</span>`).join('')}
							</div>
						`}
						</div>
					</div>
					<div class="card__link flex flex-align-center">
						<span>Read more</span>
						<div class="card__link__arrow button__arrow">
							<svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_883_12949)">
									<mask id="path-1-inside-1_883_12949" fill="white">
										<path d="M0.123558 14L10 6.76356L0 0"/>
									</mask>
									<path d="M10 6.76356L10.591 7.57021L11.7366 6.73086L10.5602 5.93523L10 6.76356ZM0.123558 14L0.714588 14.8067L10.591 7.57021L10 6.76356L9.40897 5.95691L-0.467471 13.1934L0.123558 14ZM10 6.76356L10.5602 5.93523L0.560244 -0.828327L0 0L-0.560244 0.828327L9.43976 7.59189L10 6.76356Z" fill="#2B3638" mask="url(#path-1-inside-1_883_12949)"/>
								</g>
								<defs>
									<clipPath id="clip0_883_12949">
										<rect width="10" height="14" fill="white"/>
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
				</div>
			</a>
		</div>

	`
}

function renderLoadTrigger() {
	const loading = document.querySelector('.loading')
	if (!loading) return

	const loadPosts = `<div class="load-posts"></div>`
	const noPosts = `<div class="no-posts"><h4 class="heading-5 margin-top-4">No more posts to display</h4></div>`

	if (currentPage < totalPages ) {
		loading.innerHTML = loadPosts
	}
}

function intersector() {
	const loading = document.querySelector('.loading')
	if (!loading) return

	const observer = new IntersectionObserver(
		entries => {
			entries.forEach(() => loadPosts())
		},
		{ threshold: 1 }
	)

	observer.observe(loading)
}

function setupFilters(el) {
	if (!container) return
	if (filterButtons.length) {
		filterButtons.forEach(el => el.addEventListener('click', filterPosts))
	}

	if (value) {
		if (filterButtons.length) {
			filterButtons.forEach(el => {
				const termID = parseInt(el.getAttribute('data-term'))
				if (termID === value) {
					el.classList.add('active')
					if (resetFilters) resetFilters.classList.add('active')
				}
			})
		} else {
			if (resetFilters) resetFilters.classList.add('active')
		}
	}

	if (resetFilters) resetFilters.addEventListener('click', clearFilters)

	if (value) {
		getPosts({ query: { [filterCategory]: value } })
	} else {
		getPosts({})
	}

	intersector()
}

[...document.querySelectorAll(".filtered-posts")].forEach(setupFilters);